export const PROTOCOL_VERSION = 1;
/** Sentinel project ID for global (platform-managed) on-demand pools */
export const GLOBAL_PROJECT_ID = 'global';
export var Kind;
(function (Kind) {
    Kind["Hello"] = "hello";
    Kind["Ack"] = "ack";
    // Streaming snapshot (replaces single Snapshot)
    Kind["SnapshotStart"] = "snapshot.start";
    Kind["SnapshotChunk"] = "snapshot.chunk";
    Kind["SnapshotEnd"] = "snapshot.end";
    Kind["Cmd"] = "cmd";
    Kind["Evt"] = "evt";
    Kind["Err"] = "err";
    Kind["Tick"] = "tick";
    Kind["Ping"] = "ping";
    Kind["Pong"] = "pong";
})(Kind || (Kind = {}));
export var CmdType;
(function (CmdType) {
    CmdType["ProjectCreate"] = "project.create";
    CmdType["ProjectUpdate"] = "project.update";
    CmdType["ApplicationCreate"] = "application.create";
    CmdType["ApplicationUpdate"] = "application.update";
    CmdType["ApplicationMove"] = "application.move";
    CmdType["ProfileToggle"] = "profile.toggle";
    CmdType["ApplicationSetDefaultVersion"] = "application.set_default_version";
    // Onboarding commands
    CmdType["OnboardingGetProgress"] = "onboarding.get_progress";
    CmdType["OnboardingSetOrgName"] = "onboarding.set_org_name";
    CmdType["OnboardingSelectPlan"] = "onboarding.select_plan";
    CmdType["OnboardingVerifyPayment"] = "onboarding.verify_payment";
    CmdType["OnboardingComplete"] = "onboarding.complete";
    CmdType["OnboardingGetPlans"] = "onboarding.get_plans";
    // Subscription commands
    CmdType["SubscriptionVerify"] = "subscription.verify";
    // JWKS/Auth commands
    CmdType["ProjectGenerateJwks"] = "project.generate_jwks";
    CmdType["ProjectGenerateAnonymousJwks"] = "project.generate_anonymous_jwks";
    CmdType["ProjectToggleAnonymous"] = "project.toggle_anonymous";
    CmdType["ProjectGetAnonymousToken"] = "project.get_anonymous_token";
})(CmdType || (CmdType = {}));
export var EvtType;
(function (EvtType) {
    // Project events
    EvtType["ProjectCreated"] = "project.created";
    EvtType["ProjectUpdated"] = "project.updated";
    EvtType["ProjectDeleted"] = "project.deleted";
    EvtType["ProjectsListed"] = "projects.listed";
    EvtType["ProjectFetched"] = "project.fetched";
    // Application events
    EvtType["ApplicationCreated"] = "application.created";
    EvtType["ApplicationUpdated"] = "application.updated";
    EvtType["ApplicationMoved"] = "application.moved";
    EvtType["ApplicationDeleted"] = "application.deleted";
    EvtType["ApplicationsListed"] = "applications.listed";
    // Version events
    EvtType["VersionCreated"] = "version.created";
    EvtType["VersionDeleted"] = "version.deleted";
    EvtType["VersionsListed"] = "versions.listed";
    // Profile (DeploymentProfile) events
    EvtType["ProfileCreated"] = "profile.created";
    EvtType["ProfileUpdated"] = "profile.updated";
    EvtType["ProfileDeleted"] = "profile.deleted";
    EvtType["ProfilesListed"] = "profiles.listed";
    EvtType["ProfileFetched"] = "profile.fetched";
    // Pool membership (new-model) coverage: resolver-correct "which pools
    // provision this app?" snapshot slice + change event.
    EvtType["AppPoolCoverageChanged"] = "app.pool_coverage_changed";
    // Onboarding events
    EvtType["OnboardingStateChanged"] = "onboarding.state_changed";
    EvtType["OnboardingCompleted"] = "onboarding.completed";
    EvtType["StripeCheckoutCreated"] = "stripe.checkout_created";
    EvtType["PaymentVerified"] = "payment.verified";
    EvtType["SubscriptionCreated"] = "subscription.created";
    EvtType["SubscriptionUpdated"] = "subscription.updated";
})(EvtType || (EvtType = {}));
// === Upload protocol additions ===
export var UploadCmdType;
(function (UploadCmdType) {
    UploadCmdType["UploadCreate"] = "upload.create";
    UploadCmdType["UploadSign"] = "upload.sign";
    UploadCmdType["UploadComplete"] = "upload.complete";
    UploadCmdType["UploadAbort"] = "upload.abort";
    UploadCmdType["UploadReport"] = "upload.report";
    UploadCmdType["UploadList"] = "upload.list";
    UploadCmdType["UploadStatus"] = "upload.status";
    UploadCmdType["UploadPause"] = "upload.pause";
    UploadCmdType["UploadResume"] = "upload.resume"; // resume upload
})(UploadCmdType || (UploadCmdType = {}));
export var UploadEvtType;
(function (UploadEvtType) {
    UploadEvtType["UploadProgress"] = "upload.progress";
    UploadEvtType["UploadCompleted"] = "upload.completed";
    UploadEvtType["UploadAborted"] = "upload.aborted";
    UploadEvtType["UploadPaused"] = "upload.paused";
    UploadEvtType["UploadResumed"] = "upload.resumed";
    UploadEvtType["UploadInterrupted"] = "upload.interrupted";
    UploadEvtType["UploadExpired"] = "upload.expired";
    UploadEvtType["UploadCleanedUp"] = "upload.cleaned_up"; // metadata fully removed
})(UploadEvtType || (UploadEvtType = {}));
export var MappingCmdType;
(function (MappingCmdType) {
    MappingCmdType["Upsert"] = "mapping.upsert";
    MappingCmdType["Delete"] = "mapping.delete";
})(MappingCmdType || (MappingCmdType = {}));
export var MappingEvtType;
(function (MappingEvtType) {
    MappingEvtType["Upserted"] = "mapping.upserted";
    MappingEvtType["Deleted"] = "mapping.deleted";
})(MappingEvtType || (MappingEvtType = {}));
export var DeleteCmdType;
(function (DeleteCmdType) {
    DeleteCmdType["VersionDelete"] = "version.delete";
})(DeleteCmdType || (DeleteCmdType = {}));
export var VersionCmdType;
(function (VersionCmdType) {
    VersionCmdType["Update"] = "version.update";
})(VersionCmdType || (VersionCmdType = {}));
export var VersionEvtType;
(function (VersionEvtType) {
    VersionEvtType["Updated"] = "version.updated";
})(VersionEvtType || (VersionEvtType = {}));
export var DeleteMoreCmdType;
(function (DeleteMoreCmdType) {
    DeleteMoreCmdType["ApplicationDelete"] = "application.delete";
    DeleteMoreCmdType["ProfileDelete"] = "profile.delete";
    DeleteMoreCmdType["ProjectDelete"] = "project.delete";
    DeleteMoreCmdType["MappingDelete"] = "mapping.delete";
})(DeleteMoreCmdType || (DeleteMoreCmdType = {}));
// ============================================================================
// DEPLOYMENT PROFILE PROTOCOL TYPES
// ============================================================================
export var ProfileCmdType;
(function (ProfileCmdType) {
    // Profile CRUD operations
    ProfileCmdType["ProfileCreate"] = "profile.create";
    ProfileCmdType["ProfileUpdate"] = "profile.update";
    ProfileCmdType["ProfileActivate"] = "profile.activate";
    ProfileCmdType["ProfileDeactivate"] = "profile.deactivate";
    // Profile-Application mapping operations
    ProfileCmdType["ProfileMapApplication"] = "profile.map_application";
    ProfileCmdType["ProfileUnmapApplication"] = "profile.unmap_application";
    ProfileCmdType["ProfileUpdateMapping"] = "profile.update_mapping";
    // Batch operations
    ProfileCmdType["ProfileBatchMapApplications"] = "profile.batch_map_applications";
    ProfileCmdType["ProfileBatchUnmapApplications"] = "profile.batch_unmap_applications";
    // Admin operations
    ProfileCmdType["ProfileForcePushConfig"] = "profile.force_push_config";
    ProfileCmdType["ProfileGenerateWorkerToken"] = "profile.generate_worker_token";
})(ProfileCmdType || (ProfileCmdType = {}));
export var ProfileEvtType;
(function (ProfileEvtType) {
    // Profile lifecycle events
    ProfileEvtType["ProfileCreated"] = "profile.created";
    ProfileEvtType["ProfileDeleted"] = "profile.deleted";
    ProfileEvtType["ProfileActivated"] = "profile.activated";
    ProfileEvtType["ProfileDeactivated"] = "profile.deactivated";
    // Mapping events
    ProfileEvtType["ProfileApplicationMapped"] = "profile.application_mapped";
    ProfileEvtType["ProfileApplicationUnmapped"] = "profile.application_unmapped";
    ProfileEvtType["ProfileMappingUpdated"] = "profile.mapping_updated";
    // Batch events
    ProfileEvtType["ProfileApplicationsBatchMapped"] = "profile.applications_batch_mapped";
    ProfileEvtType["ProfileApplicationsBatchUnmapped"] = "profile.applications_batch_unmapped";
    // Error recovery events
    ProfileEvtType["ProfileOperationFailed"] = "profile.operation_failed";
})(ProfileEvtType || (ProfileEvtType = {}));
// ============================================================================
// POOL (DEPLOYMENT PROFILE RUNTIME) PROTOCOL TYPES
// ============================================================================
export var PoolCmdType;
(function (PoolCmdType) {
    PoolCmdType["GetStats"] = "pool.get_stats";
})(PoolCmdType || (PoolCmdType = {}));
export var PoolEvtType;
(function (PoolEvtType) {
    PoolEvtType["Stats"] = "pool.stats";
})(PoolEvtType || (PoolEvtType = {}));
// ============================================================================
// ERROR CODES
// ============================================================================
export var ProfileErrorCode;
(function (ProfileErrorCode) {
    // Profile errors
    ProfileErrorCode["ProfileNotFound"] = "profile_not_found";
    ProfileErrorCode["ProfileNameConflict"] = "profile_name_conflict";
    ProfileErrorCode["ProfileSlugConflict"] = "profile_slug_conflict";
    ProfileErrorCode["ProfileQuotaExceeded"] = "profile_quota_exceeded";
    ProfileErrorCode["ProfileHasMappings"] = "profile_has_mappings";
    ProfileErrorCode["ProfileInvalidRegion"] = "profile_invalid_region";
    ProfileErrorCode["ProfileInvalidType"] = "profile_invalid_type";
    ProfileErrorCode["ProfileConcurrencyConflict"] = "profile_concurrency_conflict";
    // Mapping errors
    ProfileErrorCode["ApplicationNotFound"] = "application_not_found";
    ProfileErrorCode["VersionNotFound"] = "version_not_found";
    ProfileErrorCode["MappingNotFound"] = "mapping_not_found";
    ProfileErrorCode["MappingAlreadyExists"] = "mapping_already_exists";
    ProfileErrorCode["MappingQuotaExceeded"] = "mapping_quota_exceeded";
    // Permission errors
    ProfileErrorCode["ProfilePermissionDenied"] = "profile_permission_denied";
    ProfileErrorCode["ProjectPermissionDenied"] = "project_permission_denied";
    // Validation errors
    ProfileErrorCode["InvalidProfileName"] = "invalid_profile_name";
    ProfileErrorCode["InvalidProfileSettings"] = "invalid_profile_settings";
    ProfileErrorCode["InvalidCapacitySchedule"] = "invalid_capacity_schedule";
    ProfileErrorCode["InvalidMappingSettings"] = "invalid_mapping_settings";
})(ProfileErrorCode || (ProfileErrorCode = {}));
// ============================================================================
// ONBOARDING ERROR CODES
// ============================================================================
export var OnboardingErrorCode;
(function (OnboardingErrorCode) {
    // Connection and authentication errors
    OnboardingErrorCode["NoOrganization"] = "no_organization";
    OnboardingErrorCode["Unauthorized"] = "unauthorized";
    OnboardingErrorCode["InvalidToken"] = "invalid_token";
    // Onboarding flow errors
    OnboardingErrorCode["InvalidOrgName"] = "invalid_org_name";
    OnboardingErrorCode["InvalidPlan"] = "invalid_plan";
    OnboardingErrorCode["InvalidStateTransition"] = "invalid_state_transition";
    OnboardingErrorCode["OnboardingAlreadyComplete"] = "onboarding_already_complete";
    // Plan selection errors
    OnboardingErrorCode["MissingOrgName"] = "missing_org_name";
    OnboardingErrorCode["MissingPlanSelection"] = "missing_plan_selection";
    OnboardingErrorCode["PlanQuotaExceeded"] = "plan_quota_exceeded";
    // Payment errors
    OnboardingErrorCode["PaymentFailed"] = "payment_failed";
    OnboardingErrorCode["PaymentSessionExpired"] = "payment_session_expired";
    OnboardingErrorCode["PaymentSessionMismatch"] = "payment_session_mismatch";
    OnboardingErrorCode["InvalidSession"] = "invalid_session";
    OnboardingErrorCode["StripeNotConfigured"] = "stripe_not_configured";
    // Organization creation errors
    OnboardingErrorCode["OrgCreationFailed"] = "org_creation_failed";
    OnboardingErrorCode["ClerkOrgExists"] = "clerk_org_exists";
    OnboardingErrorCode["InvalidOrgId"] = "invalid_org_id";
    // Generic errors
    OnboardingErrorCode["InternalError"] = "internal_error";
    OnboardingErrorCode["DatabaseTimeout"] = "database_timeout";
    OnboardingErrorCode["StripeApiTimeout"] = "stripe_api_timeout";
})(OnboardingErrorCode || (OnboardingErrorCode = {}));
// ============================================================================
// LOCAL VERSION PROTOCOL TYPES
// ============================================================================
export var LocalVersionCmdType;
(function (LocalVersionCmdType) {
    LocalVersionCmdType["Create"] = "local_version.create";
    LocalVersionCmdType["Update"] = "local_version.update";
    LocalVersionCmdType["Delete"] = "local_version.delete";
    LocalVersionCmdType["GetTokens"] = "local_version.get_tokens";
    LocalVersionCmdType["CycleTokens"] = "local_version.cycle_tokens";
})(LocalVersionCmdType || (LocalVersionCmdType = {}));
export var LocalVersionEvtType;
(function (LocalVersionEvtType) {
    LocalVersionEvtType["Created"] = "local_version.created";
    LocalVersionEvtType["Updated"] = "local_version.updated";
    LocalVersionEvtType["Deleted"] = "local_version.deleted";
    LocalVersionEvtType["TokensCycled"] = "local_version.tokens_cycled";
})(LocalVersionEvtType || (LocalVersionEvtType = {}));
// ============================================================================
// LOCAL VERSION ERROR CODES
// ============================================================================
export var LocalVersionErrorCode;
(function (LocalVersionErrorCode) {
    LocalVersionErrorCode["VersionNotFound"] = "local_version_not_found";
    LocalVersionErrorCode["NotLocalVersion"] = "not_local_version";
    LocalVersionErrorCode["LabelConflict"] = "local_version_label_conflict";
    LocalVersionErrorCode["QuotaExceeded"] = "local_version_quota_exceeded";
    LocalVersionErrorCode["ApplicationNotFound"] = "application_not_found";
    LocalVersionErrorCode["KeysNotFound"] = "local_version_keys_not_found";
    LocalVersionErrorCode["PermissionDenied"] = "local_version_permission_denied";
})(LocalVersionErrorCode || (LocalVersionErrorCode = {}));
// ============================================================================
// CUSTOM HOSTNAME PROTOCOL TYPES
// ============================================================================
export var CustomHostnameCmdType;
(function (CustomHostnameCmdType) {
    CustomHostnameCmdType["Create"] = "custom_hostname.create";
    CustomHostnameCmdType["Delete"] = "custom_hostname.delete";
    CustomHostnameCmdType["Refresh"] = "custom_hostname.refresh";
})(CustomHostnameCmdType || (CustomHostnameCmdType = {}));
export var CustomHostnameEvtType;
(function (CustomHostnameEvtType) {
    CustomHostnameEvtType["Created"] = "custom_hostname.created";
    CustomHostnameEvtType["Updated"] = "custom_hostname.updated";
    CustomHostnameEvtType["Deleted"] = "custom_hostname.deleted";
})(CustomHostnameEvtType || (CustomHostnameEvtType = {}));
// ============================================================================
// CUSTOM HOSTNAME ERROR CODES
// ============================================================================
export var CustomHostnameErrorCode;
(function (CustomHostnameErrorCode) {
    CustomHostnameErrorCode["NotFound"] = "custom_hostname_not_found";
    CustomHostnameErrorCode["AlreadyExists"] = "custom_hostname_already_exists";
    CustomHostnameErrorCode["InvalidHostname"] = "custom_hostname_invalid";
    CustomHostnameErrorCode["ProjectNotFound"] = "project_not_found";
    CustomHostnameErrorCode["FeatureDisabled"] = "custom_domains_not_enabled";
    CustomHostnameErrorCode["PlanQuotaExceeded"] = "custom_domains_plan_quota_exceeded";
    CustomHostnameErrorCode["OrgQuotaExceeded"] = "custom_domains_org_quota_exceeded";
    CustomHostnameErrorCode["CloudflareError"] = "cloudflare_api_error";
    CustomHostnameErrorCode["PermissionDenied"] = "custom_hostname_permission_denied";
})(CustomHostnameErrorCode || (CustomHostnameErrorCode = {}));
